








import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import clamp from 'lodash/clamp';

@Component
export default class InplaceProgressBar extends Vue {
    @Prop() public progress?: number;
    @Prop({ type: Boolean, default: true }) public infinity!: boolean;

    public get styles() {
        const progress = clamp((this.progress || 0), 0.0, 1.0);
        return { width: progress * 100 + '%' };
    }
}
